import { useMemo } from 'react';
import { uniqBy } from 'lodash';

import { getResourceTagLabel } from 'src/data/performance';

interface Resource {
  tags?: string[];
}

interface UseResourcesUniqueTagsParams {
  resources: Resource[];
}

/**
 * Hook that extracts unique tags from resources
 * @param params Object containing resources array
 * @returns Array of unique tag labels
 */
export const useResourcesUniqueTags = ({ resources }: UseResourcesUniqueTagsParams): string[] => {
  return useMemo(() => {
    return uniqBy(
      resources.flatMap((resource) => (resource.tags || []).map((tag) => getResourceTagLabel(tag))),
      (label) => label.toLowerCase()
    );
  }, [resources]);
};
